import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import { spacing } from '@mui/system'

export const CvPaper = styled(props => <Paper {...props}>{props.children}</Paper>)(spacing)
